// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__e_74m","search":"Settings_search__5jm_H","filter":"Settings_filter__3grLf"};